export enum QUERY_PARAMS {
  BH_THEME = 'bh_theme',
}
